export const getMemorialPhotos = () => require("./memorial_photos.json");
